<template>
	<v-tabs 
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
		<v-tab key="Categorie" ripple class="secondary-tab">
			Categorie
		</v-tab>
		<v-tab key="Materiali" ripple class="secondary-tab" v-if="$store.getters.checkModulePermissions('banci')">
			Materiali
		</v-tab>
		<v-tab key="Cartelle Colori" ripple class="secondary-tab" v-if="$store.getters.checkModulePermissions('banci')">
			Cartelle Colori
		</v-tab>
		<v-tab key="Tessiture" ripple class="secondary-tab" v-if="$store.getters.checkModulePermissions('banci')">
			Tessiture
		</v-tab>
		<v-tab key="Altromarbec" ripple class="secondary-tab" v-if="$store.getters.checkModulePermissions('marbec')">
			Schede di Sicurezza
		</v-tab>
        <v-tab key="Contratti di servizio" ripple class="secondary-tab">
			Contratti di servizio
		</v-tab>
        <v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="pb-offset background-1 pt-3" key="Campi">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector
						model-def="product"
					></fields-selector>
				</v-col>
			</v-row>

		</v-tab-item>
		
		<v-tab-item class="pb-offset background-1 pt-3" key="Azioni">
			<v-row class="ma-0 pb-offset">
				
				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="product"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Categorie">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
                    <crud
                        title='Categorie prodotti'
                        action-icon='widgets'
                        model-def='productcategories'
                        action-position='absolute'
                        crudDialog
                    ></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
                    <crud
                        title="Unità di misura"
                        action-icon='settings'
                        model-def='generaltypes-product_unit'
                        action-position='absolute'
                        crudDialog
                    ></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
					<crud
						title="Brand"
						action-icon='settings'
						model-def='generaltypes-product_brand'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>				
			</v-row>
		</v-tab-item>
        
        <v-tab-item class="pb-offset background-1 pt-3" key="Materiali" v-if="$store.getters.checkModulePermissions('banci')">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
                    <crud
                        title="Materiali prodotti"
                        action-icon='settings'
                        model-def='generaltypes-product_material'
                        action-position='absolute'
                        crudDialog
                    ></crud>
				</v-col>
			</v-row>
		</v-tab-item>
        
        <v-tab-item class="pb-offset background-1 pt-3" key="Cartelle Colori" v-if="$store.getters.checkModulePermissions('banci')">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
                    <crud
                        title="Cartelle Colori"
                        action-icon='settings'
                        model-def='generaltypes-product_color_card'
                        action-position='absolute'
                        crudDialog
                    ></crud>
				</v-col>
			</v-row>
		</v-tab-item>
        
        <v-tab-item class="pb-offset background-1 pt-3" key="Tessiture" v-if="$store.getters.checkModulePermissions('banci')">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
                    <crud
                        title="Tessiture"
                        action-icon='settings'
                        model-def='generaltypes-product_weaving'
                        action-position='absolute'
                        crudDialog
                    ></crud>
				</v-col>
			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Altromarbec" v-if="$store.getters.checkModulePermissions('marbec')">
			<product-datasheet
			></product-datasheet>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Contratti di servizio">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
                    <crud
                        title="Contratti di Servizio"
                        action-icon='mdi-file-sign'
                        model-def='servicecontracts'
                        action-position='absolute'
                        crudDialog
                    ></crud>
				</v-col>
			</v-row>
		</v-tab-item>
	
		
		<v-tab-item class="pb-offset background-1 pt-3" key="Altro">
			<products-options
			></products-options>
		</v-tab-item>

	</v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import ProductDatasheet from '@/components/modules/products/settings/ProductDatasheet'
import ProductsOptions from '@/components/modules/products/settings/ProductsOptions'

	export default {
		name:'products-settings',
        components: {
			FieldsSelector,
			ActionsSelector,
            ProductsOptions,
            ProductDatasheet,
        },		
	}
  </script>
